import axios from "axios";
import qs from "qs";
import { analytics } from "../firebase";

function parseJwt(token) {
  var base64Url = token.split(".")[1];
  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  var jsonPayload = decodeURIComponent(
    atob(base64)
      .split("")
      .map(function(c) {
        return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join("")
  );

  return JSON.parse(jsonPayload);
}
const analyticsEvent = (eventName, data) => {
  analytics.logEvent(eventName, data);
};

const getCookie = cname => {
  const name = cname + "=";
  const ca = document.cookie.split(";");
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
};

const fireClevertapEvent = async data => {
  const userId = getCookie("userId");

  const event = {
    event: "nodeMainCTEvents",
    properties: {
      identity: userId,
      evtName: data.event,
      evtData: {
        ...data.body
      }
    }
  };
  if (data.oldUserId && data.oldUserId !== data.newUserId) {
    await fireClevertapEventProfileUpdate(
      {
        newIdentity: data.newUserId
      },
      data.oldUserId
    );
  }
  try {
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    };
    const data = qs.stringify({
      data: Buffer.from(JSON.stringify([event])).toString("base64")
    });

    await axios
      .post("https://analytics.projectcarmen.com/events/track", data, config)
      .catch(err => {
        console.log(err.message, err.stack);
      });
  } catch (err) {
    console.log(err.message, err.stack);
  }
};
const fireClevertapEventProfileUpdate = async (data, userId) => {
  const event = {
    event: "nodeMainCTProfileUpsert",
    properties: {
      identity: userId,
      profileData: {
        ...data
      }
    }
  };

  try {
    const config = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    };
    const data = qs.stringify({
      data: Buffer.from(JSON.stringify([event])).toString("base64")
    });

    await axios
      .post("https://analytics.projectcarmen.com/events/track", data, config)
      .catch(err => {
        console.log(err.message, err.stack);
      });
  } catch (err) {
    console.log(err.message, err.stack);
  }
};

export default { parseJwt, analyticsEvent, fireClevertapEvent, getCookie };
